export const h = {
    'common': {
        'webSuffix': '- QIDI Tech 起迪科技',
        'email': '邮箱',
        'password': '密码',
        'verificationCode': '验证码',
        'username': '用户名',
        'and': '和',
        'userAgreement': '用户协议',
        'privacyPolicy': '隐私政策',
        'copy': '版权所有 © 2025 起迪保留所有权',
        'sendVerificationCode': '发送验证码',
        'Sending': '发送中',
        'tryAgainInSeconds': '秒后重试',
        "userNameRequired": "请输入用户名",
        "passwordInputLabel": "请输入密码",
        "checkPasswordInputLabel": "请输入确认密码",
        "userEmailRequired": "请输入邮箱地址",
        "userEmailInvalid": "请输入正确的邮箱地址",
        "emailCodeRequired": "请输入验证码",
        "newPasswordInputLabel": "请输入新密码",
        "confirmPasswordInputLabel": "请再次输入密码",
        "passwordMismatchErrorLabel": "两次输入密码不一致",
        "agreementRequired": "请阅读并同意协议",
        'tip':'提示',
        'tipAlreadyLogin':'检测到您已经登录，为您跳转到用户中心',
        'tipWelcomeBack':'欢迎回来~',
        'tipDeleteAccountFail':'删除账号失败,删除账号接口暂时关闭中',
        'pleaseAgreeFirst':'请先同意',
        'agree':'同意',
        'refuse':'拒绝',
        'tipNeedLogin':'请先登录',
        'tipChangePasswordSuccess':'修改密码成功,为您跳转到登录页面',
        'tipGetUserInfoSuccess':'获取信息成功',
        'tipGetUserInfoFail':'获取信息失败',
        'tipLoginOut':'退出登录',
        'delete':'删除',
        'back':'返回',
        'init':"初始化",


        'readAndAgree': '我同意',
        'passwordInputLengthErrorLabel':"密码长度应该在6到20之间",
        'changePasswordFail':"原密码错误",
        'tipDeleteAccountSuccess':"删除账户成功",
        'emailCodeSentSuccess':"验证码已下发",
        'emailCodeSentFail':"验证码下发失败",
        'emailLoginFail':"验证码已过期",
        'passwordLoginFail':"登录密码错误",
        'editUserInfoSuccess':"修改用户信息成功",
        'registerSuccess':"注册成功",
        'registerFail':"注册失败",
        'registerEmailExistFail':"邮箱已存在",

        'resMessageTip0':"未知信息",
        'resMessageTip1':"密码错误",
        'resMessageTip2':"密码长度应该在6到20之间",
        'resMessageTip3':"账号错误",
        'resMessageTip4':"验证码已下发",
        'resMessageTip5':"验证码下发失败",
        'resMessageTip6':"验证码已过期",
        'resMessageTip7':"密码错误",
        'resMessageTip8':"密码不可以与旧密码相同",
        'resMessageTip9':"邮箱已存在",
        'resMessageTip10':"注册成功",
        'resMessageTip11':"注册失败",
        'resMessageTip12':"修改用户信息成功",
        'resMessageTip13':"修改用户信息失败",
        'resMessageTip14':"获取成功",
        'resMessageTip15':"获取失败",
        'resMessageTip16':"修改密码成功",
        'resMessageTip17':"修改密码失败",
        'resMessageTip18':"重置密码成功",
        'resMessageTip19':"重置密码失败",
        'resMessageTip20':"登录成功",
        'resMessageTip21':"登录失败",
        'resMessageTip22':"删除账号成功",
        'resMessageTip23':"删除账号失败",
        'resMessageTip24':"验证码有误",

        'noUserInfoError':"网络错误,请重新登录",

    },
    'changePassword': {
        'newPassword':'新密码',
    },
    'deleteUser': {
        'tipDeleteUser':'很遗憾您要离开了。一旦您的账号被删除，您所有的个人数据将永久消失且无法恢复。',
        'accountDeletionTerms':'账号删除条款',
    },
    'forgetPassword': {
        'retrievePasswordThroughEmail':'通过邮箱找回密码',
        'confirmPassword':'确认密码',
        'resettingPassword': "重置密码",
        'resetting': "重置",
    },
    'login': {
        'passwordLogin': '密码登录',
        'verifyLogin': '验证登录',
        'accountRegistration': '账号注册',
        'forgotPassword': '忘记密码',
        'login': '登录',
        'localLogin':'本地登录',
        'loginOut':'登出',
        'continueOnYourWay':'继续前往',
    },
    'register': {
        'registerAnAccount': "注册账号",
        'register': "注册",
    },
    'userCenter': {
        'personalInformation':'个人资料',
        'modifyInformation':'修改信息',
        'changePassword':'修改密码',
        'cancelAccount':'注销账号',
        'exitAccount':'退出账号',
        'change':'修改',
        'maxCharLimitTip': '用户名长度不能超过10个汉字',
    },
    'policies': {
        'deleteAccountPrivacy': '删除账号协议',
        'agreement': '使用协议',
        'privacyPolicy': '隐私政策',
    },
    "api": {},
    "errorMsg": {},
    'area': {
        'regionalSelection': '选择你的国家或地区',
        'recommendedVisits': '推荐访问',
        'NorthAmerica': '北美洲',
        'Europe': '欧洲',
        'Asia': '亚洲',
        'Other': '其他',
    },
    'contactUs': {
        'contactUs': '联系我们',
    }
}
export const aAndL = {
    'ar': {
        'Country': '阿拉伯',
        'Language': '阿拉伯语',
    },
    'cs': {
        'Country': '捷克',
        'Language': '捷克语',
    },
    'de': {
        'Country': '德国',
        'Language': '德语',
    },
    'en': {
        'Country': '英国',
        'Language': '英语',
    },
    'es': {
        'Country': '西班牙',
        'Language': '西班牙语',
    },
    'fr': {
        'Country': '法国',
        'Language': '法语',
    },
    'he': {
        'Country': '以色列',
        'Language': '希伯来语',
    },
    'hu': {
        'Country': '匈牙利',
        'Language': '匈牙利语',
    },
    'it': {
        'Country': '意大利',
        'Language': '意大利语',
    },
    'ja': {
        'Country': '日本',
        'Language': '日语',
    },
    'ko': {
        'Country': '韩国',
        'Language': '韩语',
    },
    'nl': {
        'Country': '荷兰',
        'Language': '荷兰语',
    },
    'pt': {
        'Country': '葡萄牙',
        'Language': '葡萄牙语',
    },
    'pt_BR': {
        'Country': '葡萄牙(巴西)',
        'Language': '葡萄牙语（巴西）',
    },
    'ru': {
        'Country': '俄国',
        'Language': '俄语',
    },
    'sv': {
        'Country': '瑞典',
        'Language': '瑞典语',
    },
    'tr': {
        'Country': '土耳其',
        'Language': '土耳其语',
    },
    'uk': {
        'Country': '乌克兰',
        'Language': '乌克兰语',
    },
    'zh': {
        'Country': '中国大陆',
        'Language': '简体中文',
    },
    'zh_tw': {
        'Country': '中国台湾',
        'Language': '繁体中文',
    },
    'Canada': {
        'Country': '加拿大',
        'Language': '英语',
    },
    'United_States': {
        'Country': '美国',
        'Language': '英语',
    },
    'United_Kingdom': {
        'Country': '英国',
        'Language': '英语',
    },
    'EU_Countries': {
        'Country': '欧盟国家',
        'Language': '英语',
    },
    'Australia': {
        'Country': '澳大利亚',
        'Language': '英语',
    },
    'globalzh': {
        'Country': '全球',
        'Language': '简体中文',
    },
    'globalen': {
        'Country': 'Global',
        'Language': '英语',
    },
}



// WEBPACK FOOTER //
// ./src/i18n/lan/zh.js